import React from "react"
import { MenuContent, type MenuContentProps } from "./menu-content"

export function MenuSubmenuContent({
  side = "right",
  sideOffset = 8,
  alignOffset = -4,
  ...rest
}: MenuContentProps) {
  return <MenuContent side={side} sideOffset={sideOffset} alignOffset={alignOffset} {...rest} />
}

MenuSubmenuContent.displayName = "Menu.SubmenuContent"
